import { useState } from 'react'
import { ignitionFetch } from '~/utils/ignitionFetch'

const useReEnrolmentForm = () => {
  const [ReEnrolmentForm, setReEnrolmentForm] = useState({ loading: true, data: null, error: null })

  const getReEnrolmentForm = (serviceId, guid, token) => {
    ignitionFetch(`api/v1/re-enrolment/service/${serviceId}/historic?guid=${guid}`, token, {})
      .then(response => {
        setReEnrolmentForm({ loading: false, data: response.data, error: null })
      })
      .catch(response => {
        setReEnrolmentForm({
          loading: null,
          error: response.errors
            ? response.errors
            : 'We could not find a completed Custom Re-Enrolment Form for this child.'
        })
      })
  }

  return [ReEnrolmentForm, getReEnrolmentForm]
}

export default useReEnrolmentForm
